import { useRef } from "react";
import { Html } from "@react-three/drei";
import threeDIcon from "../../static/images/threeD-Box.png";

function ThreeDSpot({
	threeDSpot,
	selectObject,
	isPreviewComponent,
	setIsInfoThreeDSpotOpen,
	setInfoThreeDSpotDetails,
}) {
	const mesh = useRef(null);
	const onClickHandler = () => {
		if (!isPreviewComponent) {
			setIsInfoThreeDSpotOpen(true);
			setInfoThreeDSpotDetails({
				url: threeDSpot.url,
				name: threeDSpot.name,
			});
		} else {
			selectObject(threeDSpot, mesh.current);
		}
	};
	console.log("Three", threeDSpot);
	return (
		<mesh position={threeDSpot.position} ref={mesh}>
			<Html center zIndexRange={[100, 10]}>
				<img
					className="infoTextspot"
					src={threeDIcon}
					alt="infospot"
					width="35px"
					height="35px"
					onClick={(e) => {
						onClickHandler();
					}}
				/>
			</Html>
		</mesh>
	);
}
export default ThreeDSpot;
